// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AllDownloadsItem__container-cf05ca {
  margin: 2px 12px;
  height: 60px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.AllDownloadsItem__actions-c0ab1d {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease;
  height: 100%;
}

.AllDownloadsItem__container-cf05ca:hover .AllDownloadsItem__actions-c0ab1d {
  opacity: 1;
  pointer-events: auto;
}

.AllDownloadsItem__download-item-e221fa {
  display: flex;
  align-items: center;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/AllDownloads/AllDownloadsItem/AllDownloadsItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,oBAAA;EACA,8BAAA;EACA,YAAA;AACF;;AAEA;EACE,UAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AACF","sourcesContent":[".container {\n  margin: 2px 12px;\n  height: 60px;\n  box-sizing: border-box;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n}\n\n.actions {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.15s ease;\n  height: 100%;\n}\n\n.container:hover .actions {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.download-item {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AllDownloadsItem__container-cf05ca`,
	"actions": `AllDownloadsItem__actions-c0ab1d`,
	"download-item": `AllDownloadsItem__download-item-e221fa`,
	"downloadItem": `AllDownloadsItem__download-item-e221fa`
};
module.exports = ___CSS_LOADER_EXPORT___;
